import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './styles.scss';

const alertWithMessage = props => {
  const { title, message, target, targetMessage, type } = props;
  return (
    <div className={`alertWithMessage alert alert-${type}`}>
      {title &&
        <h5 className="alert-heading">{title}</h5>
      }
      <p>{message}</p>
      {target &&
        targetMessage && (
        <div className="alert-btn">
          <Link to={target} className="btn btn-sm  btn-white-gold">
            <i className="os-icon os-icon-ui-92" />
            <span>{targetMessage}</span>
          </Link>
        </div>
      )}
    </div>
  );
};

alertWithMessage.defaultProps = {
  type: 'warning',
};

alertWithMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  targetMessage: PropTypes.string,
  target: PropTypes.string,
  type: PropTypes.string,
};

export default alertWithMessage;
